import { isEmpty } from 'mojito/utils';
import MojitoModules from 'mojito/modules';
import MojitoServices from 'mojito/services';
import MojitoPresentation from 'mojito/presentation';
import { useSelector } from 'react-redux';

const { useLocalizedParams } = MojitoPresentation.Hooks;
const SportsMenu = MojitoModules.SportsMenu.module;
const InPlayMenu = MojitoModules.InPlay.InPlayMenu;
const InPlayContent = MojitoModules.InPlay.InPlayContent;
const InplayTypes = MojitoModules.InPlay.types;
const { useInPlaySportsData } = MojitoModules.Common.Hooks;
const {
    selectors: { selectFavoriteEvents },
} = MojitoServices.Favorites;
const {
    FlexPane,
    PageTitle,
    PageHeader,
    GlobalLinks,
    DocumentHead,
    EmptyContent,
    PageSplitLayout,
    DefaultHeadMetaFactory,
} = MojitoPresentation.Components;

export default function InPlayPage(props) {
    const { sportId } = useLocalizedParams();

    const {
        mojitoTools: { l10n, config, appContext, stringResolver, instanceId },
    } = props;

    const metaFactory = config.documentHeadMetaFactory || DefaultHeadMetaFactory;
    const documentHeadMetaFactory = new metaFactory(l10n);
    const isFavorites = sportId === InplayTypes.TABS.FAVORITES;
    const favoriteEvents = useSelector(selectFavoriteEvents);

    const renderDocumentHead = () => {
        const sportName = sportId && appContext.sportName(sportId);

        const headData = {
            title: '$IN_PLAY_PAGE.PAGE_TITLE',
            keywords: '$IN_PLAY_PAGE.PAGE_KEYWORDS',
            description: '$IN_PLAY_PAGE.PAGE_DESCRIPTION',
            canonical: '$IN_PLAY_PAGE.PAGE_CANONICAL',
            localizedParams: new Map([['sportName', sportName]]),
            params: {
                sportId: sportId,
            },
        };

        return <DocumentHead data={headData} metaFactory={documentHeadMetaFactory} />;
    };

    const renderPageHeader = () => {
        if (!config.showPageHeader) {
            return null;
        }

        return (
            <PageHeader
                config={config.pageHeader}
                label={stringResolver.resolveString('$IN_PLAY_PAGE.HEADER')}
            />
        );
    };

    const renderPageTitle = () => {
        if (config.showPageTitle) {
            return (
                <PageTitle
                    config={config.pageTitle}
                    text={stringResolver.resolveString('$IN_PLAY_PAGE.IN_PLAY_LOGO_TITLE')}
                />
            );
        }
    };

    const { loadDone, eventGroups, sportIds } = useInPlaySportsData(
        appContext.subscriptionResolver.sportsWithStreamingEvents(),
        instanceId
    );
    const noEventsAvailable =
        isEmpty(sportIds) || (sportId && !sportIds.includes(sportId) && !isFavorites);

    return (
        <div className="ta-InPlayPage">
            {renderDocumentHead()}
            <PageSplitLayout>
                {loadDone && noEventsAvailable ? (
                    <EmptyContent config={config.emptyContent} />
                ) : (
                    <div>
                        {renderPageTitle()}
                        {renderPageHeader()}
                        <InPlayMenu
                            selectedTab={sportId}
                            sportIds={sportIds}
                            eventGroups={eventGroups}
                            favoriteEvents={favoriteEvents}
                            hasPendingGroups={!loadDone}
                        />
                        <InPlayContent
                            selectedTab={sportId}
                            sportIds={sportIds}
                            favoriteEvents={favoriteEvents}
                            eventGroups={eventGroups}
                        />
                    </div>
                )}
                <FlexPane config={config.secondaryContentContainer}>
                    <SportsMenu />
                    <GlobalLinks />
                </FlexPane>
            </PageSplitLayout>
        </div>
    );
}
